export default __webpack_public_path__ + "static/media/loader.b45e4874.svg";